// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasks-status-wrapper {
  margin: 20px 30px;
}
.tasks-status-wrapper .fi-tasks-status-card:not(:last-child) {
  display: block;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-task-shared/tasks-status/tasks-status.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AACI;EACI,cAAA;EACA,mBAAA;AACR","sourcesContent":[".tasks-status-wrapper {\r\n    margin: 20px 30px;\r\n\r\n    .fi-tasks-status-card:not(:last-child) {\r\n        display: block;\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
